import script from "./AuthLandingLink.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthLandingLink.vue?vue&type=script&setup=true&lang=js"

import "./AuthLandingLink.vue?vue&type=style&index=0&id=167f87e1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-167f87e1"]])

export default __exports__